import { CurrentUser } from '@typeList/api/user';
import Cookies from 'js-cookie';

const USER_INFO_KEY = 'user_info';

const isBrowser = () => typeof window !== 'undefined';

const setSessionStorageItem = (key: string, value: string) => {
  if (!isBrowser()) {
    return;
  }
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    console.warn('sessionStorageへのアクセスに失敗しました。', error);
  }
};

const getSessionStorageItem = (key: string): string | undefined => {
  if (!isBrowser()) {
    return undefined;
  }
  try {
    const value = window.sessionStorage.getItem(key);
    return value === null ? undefined : value;
  } catch (error) {
    console.warn('sessionStorageへのアクセスに失敗しました。', error);
    return undefined;
  }
};

const removeSessionStorageItem = (key: string) => {
  if (!isBrowser()) {
    return;
  }
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    console.warn('sessionStorageへのアクセスに失敗しました。', error);
  }
};

// クッキー管理
export const setCookies = (key: string, token: string) => {
  Cookies.set(key, token, { expires: 7, secure: true, sameSite: 'strict' }); // 有効期限は7日間
};

export const getCookies = (key: string): string | undefined => {
  return Cookies.get(key);
};

export const removeCookies = (key: string) => {
  Cookies.remove(key);
};

// ユーザー情報
export const setCurrentUserInfo = (token: string | null | undefined) => {
  if (!token) {
    removeCurrentUserInfo();
    return;
  }
  setSessionStorageItem(USER_INFO_KEY, token);
  removeCookies(USER_INFO_KEY);
};

export const getCurrentUserInfo = (): CurrentUser | undefined => {
  const storageData = getSessionStorageItem(USER_INFO_KEY);
  if (storageData && storageData !== 'undefined' && storageData !== '') {
    try {
      return JSON.parse(storageData) as CurrentUser;
    } catch (error) {
      console.warn('sessionStorageに保存されたuser_infoの解析に失敗しました。', error);
      removeSessionStorageItem(USER_INFO_KEY);
      return undefined;
    }
  }

  const cookieData = getCookies(USER_INFO_KEY);
  if (cookieData === undefined || cookieData === '' || cookieData === 'undefined') {
    removeCurrentUserInfo();
    return undefined;
  }

  try {
    const user = JSON.parse(cookieData) as CurrentUser;
    setSessionStorageItem(USER_INFO_KEY, cookieData);
    removeCookies(USER_INFO_KEY);
    return user;
  } catch (error) {
    console.warn('user_infoクッキーの解析に失敗しました。', error);
    removeCurrentUserInfo();
    return undefined;
  }
};

export const removeCurrentUserInfo = () => {
  removeSessionStorageItem(USER_INFO_KEY);
  removeCookies(USER_INFO_KEY);
};

// 多言語情報
export const removei18next = () => {
  removeCookies('i18next');
};

// デフォルトデータパックID
export const setCurrentDefaultDatabasePackId = (id: number | null) => {
  if (id === null || id === undefined) {
    return
  }
  setCookies('default_database_pack_Id', String(id));
};

export const getCurrentDefaultDatabasePackId = (): number | undefined => {
  const cookieData = getCookies('default_database_pack_Id');
  if (cookieData === undefined) {
    return
  }
  return Number(cookieData);
};

export const removeCurrentDefaultDatabasePackId = () => {
  removeCookies('default_database_pack_Id');
};
